import axios from "axios"

const paymentApi = axios.create({
    baseURL: process.env.REACT_APP_API_URL + "/api"
})

export function getToken(registrationId, cancelCallback = null) {
    const controller = new AbortController();
    if (typeof cancelCallback == 'function')
        cancelCallback(() => { controller.abort() })

    return paymentApi.get(`/payment/getToken/${registrationId}`, {
        signal: controller.signal
    })
}

export function verify(transactionId, cancelCallback = null) {
    const controller = new AbortController();
    if (typeof cancelCallback == 'function')
        cancelCallback(() => { controller.abort() })

    return paymentApi.get(`/payment/verify/${transactionId}`, {
        signal: controller.signal
    })
}

export function responseVerify(responseString, cancelCallback = null) {
    const controller = new AbortController();
    if (typeof cancelCallback == 'function')
        cancelCallback(() => { controller.abort() })

    return paymentApi.post(`/payment/responseVerify`, { responseString: responseString }, {
        signal: controller.signal
    })
}